import React from 'react';

import './style.sass';

import CommonCircleList from '../../../../common-components/common-circle-list';
import ScrollAnimation from '../../../../../../../../core/ScrollAnimation';

let list = {
    colorNumber: '#7927E0',
    list: [
        'наличие форм по оформлению предложений например, карт с подробным объяснением дальнейших действий',
        'наличие форм с доставкой (например, карт) с возможностью выбора удобной даты',
        'удобство использования форм обратной связи',
        'наличие онлайн консультанта или формы для вопросов',
        'описан детально процесс оформления',
        'наличие тематических гиперссылок и перелинковки',
        'оформление материала инфографикой и видео',
    ],
};

let list2 = {
    colorNumber: '#7927E0',
    list: [
        'насколько раскрыта информация о банке (устав и документы, отчеты, достижения и рейтинги, сведения о руководителях, лицензии, сертификаты и тд)',
        'насколько проработаны разделы "о банке"',
    ],
};

let list3 = {
    colorNumber: '#7927E0',
    list: [
        'в Я.Вебмастере (процент плохих и хороших, насколько содержательны отзывы)',
        'наличие отзывов на сторонних популярных площадках (плохих и хороших)',
        'отвечают ли банки-конкуренты на отзывы',
        'насколько содержательны отзывы и по делу ли они',
        'много ли отзывов описывающих обман банка',
    ],
};

let list4 = {
    colorNumber: '#7927E0',
    list: [
        'упоминания на авторитетных сайтах (какие это площадки, сколько конкурентов там размещены, сколько авторитетных площадок, насколько они авторитетны)',
        'отсутствие "токсичных ссылок" (битых или спамных сайтов)',
        'исходящие ссылки: ссылаются ли сайты банков на авторитетные источники (например, госуслуги)',
    ],
};
const SeoErrorsProxima = () => {
    return (
        <div className="errors-proxima">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <div className="errors-proxima__content">
                    <div className="errors-proxima__blocks">
                        <div className="errors-proxima__block-text">
                            <div className="errors-proxima__header">
                                Несоответствие метрикам качества Proxima
                            </div>
                            <div className="errors-proxima__text">
                                С каждым годом поисковые роботы совершенствуются, они научились
                                учитывать не только оптимизацию сайта, но и поведение пользователя
                                на странице. Сейчас данный параметр учитывают все поисковые системы,
                                поэтому для того, чтобы уверенно держаться в ТОП, необходимо
                                детально прорабатывать страницы со стороны юзабилити и следующих
                                метрик качества:
                            </div>
                        </div>

                        <div className="errors-proxima__block-img">
                            <img
                                src="/images/pic/seo-fintech/errors-proxima.png"
                                alt="error"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <div className="errors-proxima__subtitle">Коммерческие факторы:</div>
                    <CommonCircleList CommonCircleList={list} />

                    <div className="errors-proxima__subtitle">Анализ доверия:</div>
                    <CommonCircleList CommonCircleList={list2} />

                    <div className="errors-proxima__subtitle">Анализ отзывов:</div>
                    <CommonCircleList CommonCircleList={list3} />

                    <div className="errors-proxima__subtitle">Ссылочный анализ:</div>
                    <CommonCircleList CommonCircleList={list4} />
                </div>
            </ScrollAnimation>
        </div>
    );
};

export default SeoErrorsProxima;
